import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { WalletProvider, useWallet } from './hooks/useWallet';
import Sidebar from './components/Sidebar';
import Dashboard   from './pages/Dashboard';
import Faucet      from './pages/Faucet';
import Swap        from './pages/Swap';
import Bridge      from './pages/Bridge';
import RWA         from './pages/RWA';
import Oracle      from './pages/Oracle';
import Governance  from './pages/Governance';
import Validators  from './pages/Validators';
import Explorer    from './pages/Explorer';
import './index.css';

const pageTitles = {
  '/':           'Dashboard',
  '/faucet':     'Faucet',
  '/swap':       'Swap',
  '/bridge':     'Bridge',
  '/rwa':        'RWA Assets',
  '/oracle':     'Oracle Status',
  '/governance': 'Governance',
  '/validators': 'Validators',
  '/explorer':   'Explorer',
};

function Topbar() {
  const { blockHeight } = useWallet();
  const location = useLocation();
  const title = pageTitles[location.pathname] || 'Amitis Portal';

  return (
    <div className="topbar">
      <div className="topbar-title">{title}</div>
      <div className="topbar-right">
        {blockHeight && (
          <span className="topbar-block">Block #{blockHeight}</span>
        )}
      </div>
    </div>
  );
}

function AppShell() {
  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-content">
        <Topbar />
        <Routes>
          <Route path="/"           element={<Dashboard />} />
          <Route path="/faucet"     element={<Faucet />} />
          <Route path="/swap"       element={<Swap />} />
          <Route path="/bridge"     element={<Bridge />} />
          <Route path="/rwa"        element={<RWA />} />
          <Route path="/oracle"     element={<Oracle />} />
          <Route path="/governance" element={<Governance />} />
          <Route path="/validators" element={<Validators />} />
          <Route path="/explorer"   element={<Explorer />} />
          <Route path="*"           element={<Dashboard />} />
        </Routes>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <WalletProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </WalletProvider>
  );
}
